import { Component, OnInit, Input } from '@angular/core';
import { FormField } from '../../../common/models/form-details.model';
import { FormControl, FormGroup } from '@angular/forms';
import { WS10RadioButton, WS10RadioButtonItem } from '@vfde-fe/ngx-lib/brix/ws10-radio-button';

/** RadioButtonComponent */
@Component({
  selector: 'app-radio-button',
  templateUrl: './radio-button.component.html',
})
export class RadioButtonComponent implements OnInit {
  /** formField */
  @Input() public formField: FormField;

  /** form */
  @Input() public form: FormGroup;

  /** radioModel */
  public radioModel: WS10RadioButton;
  /** formControlName */
  public formControlName: string;

  /** ngOnInit */
  public ngOnInit (): void {
    if (this.formField) {
      this.configureComponent(this.formField);
    }
  }
  /** configureComponent
   * @method configureComponent
   * @param {FormField} data
   */
  private radioButtonCounter = 0;
   public configureComponent (data: FormField) {
    if (data && data.name && data.items && data.items.length !== 0) {
      const blockId = `block-id-${data.id}`;
      /** construct radio buttons items */
      const radioButtons = new Array<WS10RadioButtonItem>();
      for (const [i, item] of data.items.entries()) {
        radioButtons.push({
          txtLabelText: item,
          radioValue: item,
          id: `radiobutton-${data.id + this.radioButtonCounter + i}`,
          state: data.value === item ? 'checked' : null});
          this.radioButtonCounter++;
      }
      this.radioModel = {
        name: data.name,
        selectedvalue: data.value,
        items: radioButtons,
        id: blockId,
      };
      this.formControlName = data.name;
      this.form.addControl(data.name, new FormControl(data.value));
    }

  }
}
